// extracted by mini-css-extract-plugin
export default {"container":"ButtonAction_Button_container__LFelh","label":"ButtonAction_Button_label__Coa+7","icon":"ButtonAction_Button_icon__xpOmz"};